/**
 * Formatos de la tienda.
 *
 * Los precios son en pesos chilenos, sin decimales y con IVA incluido: es una
 * regla de negocio transversal (logica-negocio.md, seccion 4), no una decision
 * de cada pantalla.
 */

const PESOS = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
  maximumFractionDigits: 0,
});

/** Hasta un decimal: el eje de un grafico dice "$1,5 M", no "$1,53 M". */
const UN_DECIMAL = new Intl.NumberFormat('es-CL', { maximumFractionDigits: 1 });

const NUMERO = new Intl.NumberFormat('es-CL');

const FECHA_CORTA = new Intl.DateTimeFormat('es-CL', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const FECHA_HORA = new Intl.DateTimeFormat('es-CL', {
  day: '2-digit',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
});

/** Con año: el detalle de un pedido puede mirarse meses despues. */
const FECHA_HORA_COMPLETA = new Intl.DateTimeFormat('es-CL', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function pesos(monto: number): string {
  return PESOS.format(monto);
}

/**
 * Montos cortos para ejes de graficos: "$500", "$120 mil", "$1,5 M". A mano y
 * no con `notation: 'compact'`, que segun el motor escribe "mil" o "k".
 */
export function pesosAbreviados(monto: number): string {
  if (monto >= 1_000_000) return `$${UN_DECIMAL.format(monto / 1_000_000)} M`;
  if (monto >= 1000) return `$${UN_DECIMAL.format(monto / 1000)} mil`;
  return `$${UN_DECIMAL.format(monto)}`;
}

export function numero(valor: number): string {
  return NUMERO.format(valor);
}

/** "24 productos", o "24 productos de 310" cuando hay filtros recortando la lista. */
export function conteoProductos(total: number, totalSinFiltros = total): string {
  const texto = `${numero(total)} ${total === 1 ? 'producto' : 'productos'}`;
  return total !== totalSinFiltros ? `${texto} de ${numero(totalSinFiltros)}` : texto;
}

export function fecha(iso: string): string {
  return FECHA_CORTA.format(new Date(iso));
}

export function fechaHora(iso: string): string {
  return FECHA_HORA.format(new Date(iso));
}

export function fechaHoraCompleta(iso: string): string {
  return FECHA_HORA_COMPLETA.format(new Date(iso));
}

/** Descuento en porcentaje entero, o null si el producto no esta en oferta. */
export function porcentajeDescuento(precio: number, precioAnterior: number | null): number | null {
  if (precioAnterior === null || precioAnterior <= precio) return null;
  return Math.round((1 - precio / precioAnterior) * 100);
}
